import { Action } from '@ngrx/store';

import { LoadDataRequest, LoadDataRequestAtlas, SortInfo } from '../../global/interfaces';
import { DocumentsFilter, LoadDocumentsResponse, DocumentFileDownloadRequest } from './documents.models';
import { PaginationInfo } from 'atlas-pagination';

export enum ActionTypes {
  LOAD_DOCUMENTS = '[Client - Documents] Load Documents Action',
  LOAD_DOCUMENTS_SUCCESS = '[Client - Documents] Load Documents Success Action',
  LOAD_DOCUMENTS_FAILED = '[Client - Documents] Load Documents Failed Action',

  LOAD_MOBILE_DOCUMENTS = '[Client - Documents] Load Mobile Documents Action',
  LOAD_MOBILE_DOCUMENTS_SUCCESS = '[Client - Documents] Load Mobile Documents Success Action',
  LOAD_MOBILE_DOCUMENTS_FAILED = '[Client - Documents] Load Mobile Documents Failed Action',

  SET_DOCUMENTS_MOBILE_PAGINATION = '[Client - Documents] Set Mobile Documents Pagination Action',

  SET_DOCUMENTS_PAGINATION = '[Client - Documents] Set Documents Pagination Action',
  SET_DOCUMENTS_SORT = '[Client - Documents] Set Documents Sort Action',

  SET_DOCUMENTS_FILTER = '[Client- Documents ] Set Documents Filter Action',
  SET_DOCUMENTS_TYPE = '[Client- Documents ] Set Documents Type Filter Action',
  SET_DOCUMENTS_FROM = '[Client- Documents ] Set Documents From Filter Action',
  SET_DOCUMENTS_TO = '[Client- Documents ] Set Documents To Filter Action',

  DOCUMENTS_FILE_DOWNLOAD = '[Client - Documents] Documents File Download Action',
  RESET_DOCUMENTS = '[Client - Documents] Reset Documents Action'
}

/**
 * Desktop
 */
export class LoadDocumentsAction implements Action {
  readonly type = ActionTypes.LOAD_DOCUMENTS;

  public constructor(public payload: LoadDataRequestAtlas) {
  }
}

export class LoadDocumentsSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_DOCUMENTS_SUCCESS;

  public constructor(public payload: LoadDocumentsResponse) {
  }
}

export class LoadDocumentsFailedAction implements Action {
  readonly type = ActionTypes.LOAD_DOCUMENTS_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Mobile
 */
export class LoadMobileDocumentsAction implements Action {
  readonly type = ActionTypes.LOAD_MOBILE_DOCUMENTS;

  public constructor(public payload: LoadDataRequestAtlas) {
  }
}

export class LoadMobileDocumentsSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_MOBILE_DOCUMENTS_SUCCESS;

  public constructor(public payload: LoadDocumentsResponse) {
  }
}

export class LoadMobileDocumentsFailedAction implements Action {
  readonly type = ActionTypes.LOAD_MOBILE_DOCUMENTS_FAILED;

  public constructor(public payload: any) {
  }
}

export class SetDocumentsMobilePaginationAction implements Action {
  public readonly type = ActionTypes.SET_DOCUMENTS_MOBILE_PAGINATION;

  public constructor(public payload: PaginationInfo) {
  }
}

/**
 * Other
 */
export class SetDocumentsFilterAction implements Action {
  readonly type = ActionTypes.SET_DOCUMENTS_FILTER;

  public constructor(public payload: DocumentsFilter) {
  }
}

export class SetDocumentsTypeFilterAction implements Action {
  readonly type = ActionTypes.SET_DOCUMENTS_TYPE;

  public constructor(public payload: string) {
  }
}

export class SetDocumentsFromFilterAction implements Action {
  readonly type = ActionTypes.SET_DOCUMENTS_FROM;

  public constructor(public payload: string) {
  }
}

export class SetDocumentsToFilterAction implements Action {
  readonly type = ActionTypes.SET_DOCUMENTS_TO;

  public constructor(public payload: string) {
  }
}

export class SetDocumentsSortAction implements Action {
  readonly type = ActionTypes.SET_DOCUMENTS_SORT;

  public constructor(public payload: SortInfo) {
  }
}

export class SetDocumentsPaginationAction implements Action {
  readonly type = ActionTypes.SET_DOCUMENTS_PAGINATION;

  public constructor(public payload: PaginationInfo) {
  }
}

export class DocumentsFileDownloadAction implements Action {
  readonly type = ActionTypes.DOCUMENTS_FILE_DOWNLOAD;

  public constructor(public payload: DocumentFileDownloadRequest) {
  }
}

export class ResetDocumentsAction implements Action {
  public readonly type = ActionTypes.RESET_DOCUMENTS;
}






export type Actions =
  LoadDocumentsAction |
  LoadDocumentsSuccessAction |
  LoadDocumentsFailedAction |
  LoadMobileDocumentsAction |
  LoadMobileDocumentsSuccessAction |
  LoadMobileDocumentsFailedAction |
  SetDocumentsMobilePaginationAction |
  SetDocumentsFilterAction |
  SetDocumentsFromFilterAction |
  SetDocumentsTypeFilterAction |
  SetDocumentsToFilterAction |
  SetDocumentsSortAction |
  SetDocumentsPaginationAction |
  DocumentsFileDownloadAction |
  ResetDocumentsAction;
